import DynamicLink from 'components/DynamicLink';
import RenderInfo from 'components/RenderInfo';
import React from 'react';
import { SALES_CHANNEL_TYPES } from 'utils';
import styles from './index.module.scss';
import SalesChannelUser from './user';

const BasicDetails = (props) => {
  const {
    fetchSalesChannelDetailsFn,
    details = {},
    details: {
      name = '',
      createdAt = '',
      description = '',
      objectId = '',
      inventoryItemsFilter = {},
      apiProvider = '',
      accessToken = '',
      storeId = '',
      markupPercent = 0,
      user: { email = '', phone = '', objectId: userId = '' } = {},
      uberClientId = '',
      uberClientSecret = '',
      stockThreshold = 0,
      useBackgroundLessImages = false,
      active = '-',
      locale = '-',
      host = '-',
      username = '-'
    } = {},
  } = props;

  const getUberCreds = () => {
    if (apiProvider !== SALES_CHANNEL_TYPES.UBER) return null;
    return (
      <>
        <RenderInfo heading='Uber Client Id' value={uberClientId} />
        <RenderInfo heading='Uber Client Secret' value={uberClientSecret} />
      </>
    );
  };
  return (
    <div className={styles['details-section']}>
      <div className={styles['info-container']}>
        <div className={styles['info']}>
          <RenderInfo heading='ID' value={objectId} />
          <RenderInfo heading='Name' value={name} />
          <RenderInfo heading='Description' value={description} />
          <RenderInfo heading='Username' value={username} />
          <RenderInfo heading='Host' value={host} />
          <RenderInfo heading='Created At' value={createdAt} type='date' />
          <RenderInfo
            heading='Inventory Items Filter'
            value={JSON.stringify(inventoryItemsFilter)}
          />
          <RenderInfo heading='Store Id' value={storeId} />
          <RenderInfo heading='Api Provider' value={apiProvider} />
          <RenderInfo
            heading='Access Token'
            value={accessToken}
            containerClass={styles['accessToken']}
          />
          {getUberCreds()}
        </div>
        <div className={styles['info']}>
          <SalesChannelUser details={details} fetchSalesChannelDetailsFn={fetchSalesChannelDetailsFn} />
          <RenderInfo heading='Email' value={email} />
          <RenderInfo heading='Phone' value={phone} />
          <RenderInfo heading='Markup Percentage' value={markupPercent} />
          <RenderInfo heading='Threshold Quantity' value={stockThreshold} />
          <RenderInfo
            heading='Use backgroundless images'
            value={useBackgroundLessImages}
            type='boolean'
          />
          <RenderInfo heading='Active' value={active} type='boolean' />
          <RenderInfo heading='Locale' value={locale} />
        </div>
      </div>
    </div>
  );
};

export default BasicDetails;
